// src/components/common/UserProfileHeader.tsx
import { useTranslation } from 'react-i18next';

import {
    Avatar, AvatarFallback, AvatarImage,
} from "@/components/ui";

type UserProfileHeaderProps = {
    name: string;
    role: string;
    avatarUrl?: string;
};

export default function UserProfileHeader({ name, role, avatarUrl = "/placeholder-avatar.jpg" }: UserProfileHeaderProps) {
    const { t } = useTranslation();

    return (
        <div className="p-2 border-b flex items-center gap-3">
            <Avatar className="h-10 w-10">
                <AvatarImage src={avatarUrl} alt={t("header.noUserImage")} />
                <AvatarFallback>PS</AvatarFallback>
            </Avatar>
            <div>
                <p className="text-sm font-medium">{name}</p>
                <p className="text-xs text-muted-foreground">{role}</p>
            </div>
        </div>
    );
} 